import axiosClient from '@/config/api/axios'
import { PROJECTS } from '@/config/api/endpoints'
import { isApiConfigured } from '@/config/api/env'

export function projectToNavProject(row = {}) {
  return {
    id: String(row.id ?? ''),
    title: String(row.name || 'Untitled project'),
    instructions: row.instructions ?? '',
    updatedAt: row.updated_at ?? row.created_at ?? null,
  }
}

export function isProjectsApiAvailable() {
  return isApiConfigured()
}

export async function fetchProjects(options = {}) {
  if (!isProjectsApiAvailable()) return []
  const { data } = await axiosClient.get(PROJECTS, { signal: options.signal })
  return (Array.isArray(data) ? data : []).map(projectToNavProject)
}

export async function createProject({ name, instructions }, options = {}) {
  if (!isProjectsApiAvailable()) return null
  const { data } = await axiosClient.post(
    PROJECTS,
    { name, instructions },
    { signal: options.signal },
  )
  return projectToNavProject(data)
}

export async function updateProject(id, patch, options = {}) {
  if (!isProjectsApiAvailable()) return null
  const body = { name: patch.name, instructions: patch.instructions }
  const { data } = await axiosClient.patch(`${PROJECTS}/${id}`, body, {
    signal: options.signal,
  })
  return projectToNavProject(data)
}
